import {
  CHANGE_STATE_MODAL_MIGRATE,
  MIGRATE_CLIENTS_REQUESTED,
  MIGRATE_CLIENTS_SUCCESS,
  MIGRATE_DEALS_REQUESTED,
  MIGRATE_DEALS_SUCCESS,
  MIGRATE_ERROR_MESSAGE,
  OPEN_ALERT_MIGRATE_SUCCESS,
  SET_INDEX_CLIENTS_REQUESTED,
  SET_INDEX_CLIENTS_SUCCESS,
  SET_INDEX_DEALS_REQUESTED,
  SET_INDEX_DEALS_SUCCESS,
} from "./actionTypes";

export const migrateClients = (payload) => ({
  type: MIGRATE_CLIENTS_REQUESTED,
  payload
})

export const getMigrateClientsSuccess = (payload) => ({
  type: MIGRATE_CLIENTS_SUCCESS,
  payload
})

export const migrateDeals = (payload) => ({
  type: MIGRATE_DEALS_REQUESTED,
  payload
})

export const getMigrateDealsSuccess = (payload) => ({
  type: MIGRATE_DEALS_SUCCESS,
  payload
})

export const migrateFailed = (payload) => ({
  type: MIGRATE_ERROR_MESSAGE,
  payload
})

export const openModalMigration = (payload) => ({
  type: CHANGE_STATE_MODAL_MIGRATE,
  payload
})

export const openAlertMigrateSuccess = () => ({
  type: OPEN_ALERT_MIGRATE_SUCCESS
})

export const setIndexClients = () => ({
  type: SET_INDEX_CLIENTS_REQUESTED
})

export const setIndexClientsSuccess = () => ({
  type: SET_INDEX_CLIENTS_SUCCESS
})

export const setIndexDeals = () => ({
  type: SET_INDEX_DEALS_REQUESTED
})

export const setIndexDealsSuccess = () => ({
  type: SET_INDEX_DEALS_SUCCESS
})